export const trackDeafSupportButtonClick = (): void => {
  // @ts-ignore
  if (window.gtag) {
    // @ts-ignore
    window.gtag('event', 'deaf_support_click', {
      event_category: 'Deaf support',
      value: 1,
    });
  }
};
